import { render, staticRenderFns } from "./FlightSchoolDetails.vue?vue&type=template&id=096f094c"
import script from "./FlightSchoolDetails.vue?vue&type=script&lang=js"
export * from "./FlightSchoolDetails.vue?vue&type=script&lang=js"
import style0 from "./FlightSchoolDetails.vue?vue&type=style&index=0&id=096f094c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports